module.exports = __webpack_public_path__ + "static/product3_4-43fe039803026bfa61debf608ea86243.jpg";